module.exports = __webpack_public_path__ + "img/learn_more.678860c1.svg";